import { isBoolean } from '@grandvisionhq/utils';
import { ExtraTypes } from './types.js';

const isGlassesType = (input)=>input === 'frameOnly' || input === 'frameAndMonofocal' || input === 'frameAndMultifocal'
;
const isExtraType = (input)=>input in ExtraTypes
;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBenefit = (input)=>input.hasOwnProperty('name') && input.hasOwnProperty('value') && isBoolean(input.value)
;

export { isBenefit, isExtraType, isGlassesType };
//# sourceMappingURL=typeguards.js.map
